import { EstimateItem } from '../types';

/** Material / equipment / fee lines with no cost entered yet. */
export function isUnpricedItem(item: EstimateItem): boolean {
  return item.type !== 'Labor' && (!item.cost || item.cost <= 0);
}

export function countUnpricedItems(items: EstimateItem[]): number {
  return items.filter(isUnpricedItem).length;
}

export function getFirstUnpricedItemId(items: EstimateItem[]): string | null {
  return items.find(isUnpricedItem)?.id ?? null;
}

export function getFirstUnpricedItem(items: EstimateItem[]): EstimateItem | null {
  return items.find(isUnpricedItem) ?? null;
}

/** Non-labor lines that still need a cost entered. */
export function countItemsNeedingPrice(items: EstimateItem[]): number {
  return items.filter(i => i.type !== 'Labor').length;
}
